import React from "react";
import { Box } from "@mui/material";
import LoginForm from "components/login/login-form";

import { Trans, } from "@lingui/macro";

import { Link } from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import "./style.css";

export class Login extends React.Component<{}, {}>
{
	render() {
		let allowPublicContent = process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "true"

		return ( 
			<Box className={"login-container"}>
				<Box className={"grid-item-logo"}>
					<Link to={"/"} className={"login-logo"}>
						<img src={`${process.env.PUBLIC_URL}/loaded-files/${process.env.REACT_APP_LOGO_FILENAME}`}
							alt="Logo" />
					</Link>
				</Box>
				<Box className={"grid-item-form"} >
					<LoginForm />
					{allowPublicContent && <Box className="link-go-back">
						<Link to={"/"} style={{
							display: "flex",
							alignItems: "center",
							color: "black",
							marginTop: "10px",
							fontSize: "15px",
						}}><ArrowBackIcon fontSize="small" /><Trans id="login-back-link">Torna alla home</Trans></Link>
					</Box>}
				</Box>
			</Box>);
	}
}
